export function subscribeToNewBlock(provider, chainId, dispatch, isActive) {
  if (provider && chainId !== undefined && isActive) {
    var update = function update(blockNumber) {
      return dispatch({
        chainId: chainId,
        blockNumber: blockNumber
      });
    };
    provider.on('block', update);
    provider.getBlockNumber().then(function (blockNumber) {
      return update(blockNumber);
    }, function (err) {
      console.error(err);
    });
    return function () {
      provider.off('block', update);
    };
  }
  return function () {
    return undefined;
  };
}